import { useEffect, useState } from 'react';
import moment from 'moment';
import { getCurrency } from 'Utils/currency-config-for-locale/currencyConfigForLocale';
import { fetchPledg } from './PledgForm.utils';

const simulatePaymentSchedule = ({ price }) =>
  fetchPledg('/simulate_payment_schedule', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      amount_cents: Math.round(price * 100),
      created: moment().format('YYYY-MM-DD'),
    }),
  });

const formatPrice = (price) => {
  const { symbol } = getCurrency('fr-FR', 'EUR');
  return `${(price / 100).toLocaleString('fr-FR')} ${symbol}`;
};

export const usePledgSchedule = ({ price }: { price: number }) => {
  const [paymentSchedule, setPaymentSchedule] = useState({ INSTALLMENT: [{ amount_cents: 0 }] });

  useEffect(() => {
    simulatePaymentSchedule({ price }).then(setPaymentSchedule);
  }, [price]);

  const installment = paymentSchedule.INSTALLMENT;
  const { amount_cents: amountCents, fees } = installment[0];

  return {
    installment,
    monthlyPayment: formatPrice(amountCents),
    fees: formatPrice(fees),
    firstPayment: formatPrice(amountCents + fees),
  };
};
